import { Routes } from '@angular/router';
import { LoginComponent } from './features/auth/login.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { TicketsComponent } from './features/tickets/tickets-list/tickets.component';
import { TicketDetailComponent } from './features/tickets/ticket-detail/ticket-detail.component';
import { AuthGuard } from './guards/auth.guard';

export const routes: Routes = [
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'tickets',
        component: TicketsComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'ticket/:odt',
        component: TicketDetailComponent,
        canActivate: [AuthGuard],
    },
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
    },
    {
        path: '**',
        redirectTo: 'login',
    },
];
